import { styled } from '@mui/system';
import { Tabs } from '@mui/material';
import { RookeryBoldFont } from 'v3/styles/common';

export const StyledTabs = styled(Tabs)(({ theme }) => ({
  borderBottom: '1px solid',
  borderColor: theme.palette.common.white,
  '& .MuiTabs-indicator': {
    backgroundColor: theme.palette.orange.light,
  },
  '& .MuiTab-root': {
    font: `700 1rem ${RookeryBoldFont}`,

    color: theme.palette.common.white,
    '&.Mui-selected': {
      color: theme.palette.common.white,
    },
    textTransform: 'none',
  },
}));
